import type { SignUpAPIResponse, SignUpFormData } from "../types/auth";
import type { APIInstance } from "./apiService";

export interface ResetPasswordResponse {
  message: string;
}

export interface ResendConfirmationResponse {
  message: string;
}

export class AuthService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async resetPasswordForEmail(email: string): Promise<ResetPasswordResponse> {
    const response = await this.api.post<ResetPasswordResponse>("/public/auth/forgot-password", {
      email,
    });
    return response.data;
  }

  async resendConfirmationEmail(email: string): Promise<ResendConfirmationResponse> {
    const response = await this.api.post<ResendConfirmationResponse>(
      "/public/auth/resend-confirmation-email",
      {
        email,
      }
    );
    return response.data;
  }

  async signup(data: SignUpFormData): Promise<SignUpAPIResponse> {
    const response = await this.api.post<SignUpAPIResponse>("/public/auth/signup", data);
    return response.data;
  }
}
